import React from "react";
import CustomDatePicker from "../../../../../components/common/DatePicker/CustomDatePicker";
import CustomTable from "../../../../../components/common/Table/CustomTable";
import TextInput from "../../../../../components/common/TextInput/TextInput";
import { renderHistoryDisburseColumn } from "../constants";

export default function CommissionHistory(props) {
  const isHistory = true;
  return (
    <div>
      <div className="d-flex filter-bar filter-bar-2">
        <TextInput
          id={"pageSize"}
          label={"Tampilkan"}
          width={60}
          handleEnter={props.handleEnter}
          value={props.filterInput.pageSize}
          handleChange={props.handleInputChange}
        />
        <TextInput
          id={"search"}
          placeholder="Cari..."
          label={"Nama Nasabah"}
          width={350}
          handleEnter={props.handleEnter}
          value={props.filterInput.search}
          handleChange={props.handleInputChange}
        />
        <div>
          <CustomDatePicker
            id={"date"}
            label={"Tanggal"}
            isRangePicker
            width={300}
            onInputChange={props.handleDateChange}
            height="35px"
          />
        </div>
      </div>
      <CustomTable
        columns={renderHistoryDisburseColumn(
          isHistory,
          props.handleDetailAgentButton
        )}
        data={props.data}
        loading={props.loading}
        handleTableChange={props.handleTableChange}
        pagination={props.tablePagination}
        scrollX={1000}
      />
    </div>
  );
}
